import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AlertAggregateRequest, AlertAggregateResponse } from '../models/aggregate.models';

@Injectable({ providedIn: 'root' })
export class AlertAggregateService {
  static readonly endpoints = {
    aggregate: `${environment.apiUrl}/AlertAPI/Aggregate`,
  };

  private http = inject(HttpClient);

  aggregate(req: AlertAggregateRequest): Observable<AlertAggregateResponse> {
    return this.http.post<AlertAggregateResponse>(AlertAggregateService.endpoints.aggregate, req);
  }
}
